export default {
    TELA_APP: 1,
    LINK: 2,
    NENHUMA: 3,
}
